export default class Translations {
  constructor(data) {
    this.InputPlaceholder = 'Postcode en/of plaats'
    this.YourCurrentLocation = 'Uw huidige locatie'
    this.FilterTitle = 'Filter op soort dealer'
    this.FilterPostText = ''
    this.Kilometers = 'km'
    this.Back = 'Terug'
    this.VisitWebsite = 'Bezoek website'
    this.RoutePlanner = 'Routebeschrijving'
    this.Link = 'Meer informatie'

    if (data) {
      if (data['Dealers.InputPlaceholder'])
        this.InputPlaceholder = data['Dealers.InputPlaceholder']
      if (data['Dealers.YourCurrentLocation'])
        this.YourCurrentLocation = data['Dealers.YourCurrentLocation']
      if (data['Dealers.FilterTitle'])
        this.FilterTitle = data['Dealers.FilterTitle']
      if (data['Dealers.FilterPostText'])
        this.FilterPostText = data['Dealers.FilterPostText']
      if (data['Dealers.Kilometers'])
        this.Kilometers = data['Dealers.Kilometers']
      if (data['Dealers.Back']) this.Back = data['Dealers.Back']
      if (data['Dealers.VisitWebsite'])
        this.VisitWebsite = data['Dealers.VisitWebsite']
      if (data['Dealers.RoutePlanner'])
        this.RoutePlanner = data['Dealers.RoutePlanner']
      if (data['Dealers.Link']) this.Link = data['Dealers.Link']
    }
  }
}
